import React, { Component } from 'react';
import { connect } from 'react-redux';
import { sortBy } from 'lodash';
import { Row, Col } from 'react-bootstrap';

import ResearchNav from './research_nav';
import ResearchSection from './research_section';
import VideosSection from './videos_section';
import CoursesSection from './courses_section';

class Research extends Component {
  render() {
    const { props } = this;
    const currSection = props.location.hash.replace('#', '');

    if (!props.sortedSections || !props.sortedSections.length) {
      return (
        <div style={{ textAlign: 'center' }}>
          Once you upload your papers to your Academia.edu profile page, they
          will be automatically be displayed here.
        </div>
      );
    }

    const hasVideos = props.videos && props.videos.length > 0;
    const hasCourses = props.courses && props.courses.length > 0;

    return (
      <Row>
        <Col xsHidden smHidden md={2} mdOffset={1}>
          <ResearchNav
            sortedSections={props.sortedSections}
            currSection={currSection}
            hasVideos={hasVideos}
            hasCourses={hasCourses}
          />
        </Col>

        <Col xsOffset={1} xs={10} md={6} mdOffset={0}>
          {hasCourses && (
            <CoursesSection
              courses={props.courses}
              currSection={currSection}
              history={props.history}
            />
          )}

          {hasVideos && (
            <VideosSection
              videos={props.videos}
              currSection={currSection}
              history={props.history}
            />
          )}

          {props.sortedSections.map((section) => (
            <ResearchSection
              section={section}
              key={section.id}
              currSection={currSection}
              history={props.history}
            />
          ))}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ sections, videos, courses }) => {
  return {
    sortedSections: sortBy(sections, 'display_order'),
    videos: videos || [],
    courses: courses || [],
  };
};

export default connect(mapStateToProps)(Research);
